import React from 'react';
import { Button } from './ui/Button'; // Adjust import path if needed
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext'; // Adjust import path if needed

/**
 * ThemeToggleButton toggles between dark and light mode.
 * Uses useTheme hook from ThemeContext.
 * 
 * THEME SYSTEM INTEGRATION:
 * This component is part of the application's theme system:
 * 1. It accesses the current theme state via useTheme()
 * 2. Toggles between dark and light modes
 * 3. Shows appropriate icon (Sun/Moon) based on current theme
 * 
 * The theme toggle affects all styled components because:
 * - It adds/removes the 'dark' class on the HTML root element
 * - CSS variables in index.css have different values for light/dark
 * - Tailwind and other styles reference these variables
 */
const ThemeToggleButton: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="rounded-full"
      aria-label="Toggle theme"
      data-testid="theme-toggle-button"
    >
      {theme === 'dark' ? (
        <Sun className="h-5 w-5 text-primary" />
      ) : (
        <Moon className="h-5 w-5 text-primary" />
      )}
    </Button>
  );
};

export default ThemeToggleButton;
